import { AuthGuard, CrudOp, tmmAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { getTargetMaterialMode, importView, usesAutomatedLogicStringGeneration } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const TMMEditorView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  const projectId = useRequiredProjectParam("projectId");
  const tmmId = useRequiredSubprojectParam("tmmId");
  const modelYear = useRequiredSubprojectParam("modelYear", (modelYear) => parseInt(modelYear));
  const mbvKeys = useRequiredSubprojectParam("mbvKeys", (mbvKeys) => mbvKeys.split(","));
  const ruleNormalizationParams = { brand, modelYear, mbvKeys };
  return (
    <AuthGuard authScope={tmmAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense>
        <LazyTMMEditorView
          targetMaterialMode={getTargetMaterialMode(brand)}
          ruleNormalizationParams={ruleNormalizationParams}
          projectId={projectId}
          tmmId={tmmId}
          usesAutomatedLogicStringGeneration={usesAutomatedLogicStringGeneration(brand)}
        />
      </Suspense>
    </AuthGuard>
  );
};

const LazyTMMEditorView = lazy(importView(
  () => import("../components/TMMEditorView"),
  (it) => it.TMMEditorView,
));
